const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        // Return just the base64 part, without the data URI prefix
        resolve(reader.result.split(',')[1]);
      } else {
        reject(new Error('Failed to read file as base64 string.'));
      }
    };
    reader.onerror = error => reject(error);
  });
};

export const extractSerialNumberFromImage = async (imageFile: File): Promise<string> => {
  try {
    const imageBase64 = await fileToBase64(imageFile);

    const response = await fetch('/api/analyze-image', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        imageBase64: imageBase64,
        mimeType: imageFile.type,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Der opstod en fejl under billedanalyse.');
    }

    const data = await response.json();
    return data.serialNumber;

  } catch (error) {
    console.error("Error extracting serial number:", error);
    // Rethrow a user-friendly message
    throw new Error(error instanceof Error ? error.message : "Kunne ikke behandle billedet. Tjek din internetforbindelse og prøv igen.");
  }
};
